import { Typography } from "@mui/material";

export function buildPhoneToolLinks(userNames: string) {
  // eslint-disable-next-line no-control-regex
  userNames = userNames.replace(/[^\x00-\x7F]/g, ""); // remove non-ascii characters
  const names = userNames.split(/[,; ]+/); // commas, semicolons, and spaces
  const filteredNames = names.filter((item) => item !== "");
  return (
    <div>
      <Typography>
        {filteredNames.map((name: any, index: any) => (
          <a
            key={index}
            href={"https://phonetool.amazon.com/users/" + name}
            target={"_blank"}
            style={{ textDecoration: "none", color: "blue" }}
            rel="noreferrer"
          >
            {name}
            {index < filteredNames.length - 1 ? ", " : ""}
          </a>
        ))}
      </Typography>
    </div>
  );
}
